'use client';

import React, { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import ValuePropositionSection from './ValuePropositionSection';
import CollaborationModelSection from './CollaborationModelSection';
import PartnerSuccessSection from './PartnerSuccessSection';
import NetworkDirectorySection from './NetworkDirectorySection';
import BenefitsCalculatorSection from './BenefitsCalculatorSection';
import ApplicationFormSection from './ApplicationFormSection';
import TestimonialsSection from './TestimonialsSection';
import FAQSection from './FAQSection';
import CTASection from './CTASection';
import FooterSection from './FooterSection';

const PartnerNetworkInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const scrollToApplication = () => {
    const applicationSection = document.getElementById('apply');
    if (applicationSection) {
      applicationSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="animate-pulse">
          <div className="h-96 bg-muted"></div>
          <div className="container mx-auto px-4 py-20">
            <div className="space-y-8">
              <div className="h-8 bg-muted rounded w-3/4 mx-auto"></div>
              <div className="h-4 bg-muted rounded w-1/2 mx-auto"></div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="h-64 bg-muted rounded"></div>
                <div className="h-64 bg-muted rounded"></div>
                <div className="h-64 bg-muted rounded"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <HeroSection onApplyClick={scrollToApplication} />
      <ValuePropositionSection />
      <CollaborationModelSection />
      <PartnerSuccessSection />
      <NetworkDirectorySection />
      <BenefitsCalculatorSection />
      <TestimonialsSection />
      <ApplicationFormSection />
      <FAQSection />
      <CTASection onApplyClick={scrollToApplication} />
      <FooterSection />
    </div>
  );
};

export default PartnerNetworkInteractive;